/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_SellInputs */

const en_svtag_sell = /** @type {(inputs: Svtag_SellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SELL`)
};

const ar_svtag_sell = /** @type {(inputs: Svtag_SellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#بيع`)
};

const bn_svtag_sell = /** @type {(inputs: Svtag_SellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SELL`)
};

const de_svtag_sell = /** @type {(inputs: Svtag_SellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SELL`)
};

const es_svtag_sell = /** @type {(inputs: Svtag_SellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SELL`)
};

const fr_svtag_sell = /** @type {(inputs: Svtag_SellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SELL`)
};

const pt_svtag_sell = /** @type {(inputs: Svtag_SellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SELL`)
};

const zh_svtag_sell = /** @type {(inputs: Svtag_SellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SELL`)
};

const tr_svtag_sell = /** @type {(inputs: Svtag_SellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SELL`)
};

const ru_svtag_sell = /** @type {(inputs: Svtag_SellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SELL`)
};

const pl_svtag_sell = /** @type {(inputs: Svtag_SellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SELL`)
};

/**
* | output |
* | --- |
* | "#SELL" |
*
* @param {Svtag_SellInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_sell = /** @type {((inputs?: Svtag_SellInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_SellInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_sell(inputs)
	if (locale === "bn") return bn_svtag_sell(inputs)
	if (locale === "de") return de_svtag_sell(inputs)
	if (locale === "es") return es_svtag_sell(inputs)
	if (locale === "fr") return fr_svtag_sell(inputs)
	if (locale === "pt") return pt_svtag_sell(inputs)
	if (locale === "zh") return zh_svtag_sell(inputs)
	if (locale === "tr") return tr_svtag_sell(inputs)
	if (locale === "ru") return ru_svtag_sell(inputs)
	if (locale === "pl") return pl_svtag_sell(inputs)
	return en_svtag_sell(inputs)
});